module.exports = __webpack_public_path__ + "img/LOGO_CASES.b7276766.png";